import { useState } from "react";
import { VistaPrazoInputCard } from "./components/vista-prazo-input-card";
import { Vis_PraResponse } from "./Vista-Prazo";
import { VistaPrazoResponse } from "./components/vista-prazo-response";

export default function VistaPrazo() {
    const [results, setResults] = useState<Vis_PraResponse | null>(null);

    return (
        <>
            <VistaPrazoInputCard setResults={setResults} />
            {results && <VistaPrazoResponse results={results} />}
        </>
    )

}
